// eslint-disable-next-line boundaries/no-unknown-files
import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { EnvModeType } from '@app/enums/env-mode-type.enum';
import { environment } from '@env/environment';

export const RCPUrlGuard: CanActivateFn = () => {
    const router = inject(Router);
    const defaultView = inject(DOCUMENT).defaultView;
    if (router.url === '/') {
        if (environment.mode != EnvModeType.LOCAL) {
            if (!defaultView) return false;
            const doc = defaultView.document;
            doc.location.href = environment.links.loginUrl;
            return false;
        }
    }
    return true;
};
